import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Convert an angle from degrees to radians (single-precision).
*
* @module @stdlib/math/base/special/deg2radf
*
* @example
* var deg2radf = require( '@stdlib/math/base/special/deg2radf' );
*
* var r = deg2radf( 90.0 );
* // returns ~1.571
*
* r = deg2radf( -45.0 );
* // returns ~-0.785
*
* r = deg2radf( NaN );
* // returns NaN
*/

// MODULES //
var deg2radf = __var_0__;


// EXPORTS //
export default deg2radf;
